import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "local_fire_department",
    title: "Fire Safety Compliance",
    description:
      "We ensure your property meets fire safety requirements, including smoke alarms, carbon monoxide detectors, and fire extinguisher provisions.",
  },
  {
    icon: "gas_meter",
    title: "Gas Safety Certification",
    description:
      "We arrange annual gas safety inspections and certification by registered engineers, as required under landlord obligations.",
  },
  {
    icon: "bolt",
    title: "Electrical Safety",
    description:
      "We coordinate periodic electrical installation condition reports (EICRs) to ensure your property's wiring and systems are safe and compliant.",
  },
  {
    icon: "eco",
    title: "BER Certification",
    description:
      "We manage Building Energy Rating assessments to ensure your property holds a valid BER certificate as required for letting.",
  },
];

function Compliance_Section1() {
  return (
    <ServiceHighlights title="Why Choose Our Landlord Compliance & Certification?" items={items} />
  );
}

export default Compliance_Section1;
